module.exports = __webpack_public_path__ + "img/64.4c70b3bd.jpg";